import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE } from '../config';

/**
 * Хук для проверки, пройдена ли анкета (онбординг).
 * Если пользователь авторизован, но анкета не пройдена — редиректит на /new-questionnaire.
 * Возвращает { loading, isOnboardingCompleted }.
 */
export default function useOnboardingGuard() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [isOnboardingCompleted, setIsOnboardingCompleted] = useState(false);

  useEffect(() => {
    let active = true;
    const token = localStorage.getItem('token');

    if (!token) {
      // Нет токена — не авторизован, пропускаем проверку (пусть страница сама редиректит на логин)
      setLoading(false);
      return;
    }

    const checkOnboarding = async () => {
      try {
        const resp = await fetch(`${API_BASE}/api/Onboarding/status`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });

        if (!active) return;

        if (resp.status === 401) {
          // Токен невалидный
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          navigate('/log_in');
          return;
        }

        if (resp.ok) {
          const data = await resp.json();
          if (data.showOnboarding) {
            // Анкета не пройдена — перенаправляем
            navigate('/new-questionnaire', { replace: true });
            return;
          }
          setIsOnboardingCompleted(true);
        }
      } catch (e) {
        console.warn('Onboarding status check failed', e);
      } finally {
        if (active) setLoading(false);
      }
    };

    checkOnboarding();
    return () => { active = false; };
  }, [navigate]);

  return { loading, isOnboardingCompleted };
}
